import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import selectionArrowIcon from "src/assets/images/icons/selection-arrow.png";
import { color } from "src/styles/variables";

const razorImage =
  "https://images.ctfassets.net/itvcls9imtx8/47s44WxSAgGcAGs2IO4SQi/2d296c68f468bc0f0ae598d2b51bcf0e/razor-v2.png";

const goldRazorImage =
  "https://images.ctfassets.net/itvcls9imtx8/CLswAM5ttIaYQESkQooc8/c53bd73df79ea95440c6d5e199bc6009/gold_handle_side.png";

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const indexes = "012".split("");

function RazorEngraving({ engraving = "", updateEngraving, gold, children }) {
  return (
    <Wrapper>
      {children}
      <EngravingSelection>
        {indexes.map((_, index) => (
          <Options
            data-selector="EngravingSelection-Option"
            key={index}
            engraving={engraving.split("")}
            updateEngraving={updateEngraving}
            index={index}
          />
        ))}
      </EngravingSelection>
      <Razor gold={gold}>
        <Engraving>{engraving}</Engraving>
      </Razor>
    </Wrapper>
  );
}
RazorEngraving.propTypes = {
  updateEngraving: PropTypes.func.isRequired,
  engraving: PropTypes.string,
  gold: PropTypes.bool,
  children: PropTypes.any,
};

export default RazorEngraving;

function Options({ engraving, updateEngraving, index, ...props }) {
  const onChange = (event) => {
    const newEngraving = [
      ...engraving.slice(0, index),
      event.target.value,
      ...engraving.slice(index + 1),
    ].join("");
    updateEngraving(newEngraving);
  };
  const space = " ";
  return (
    <SelectWrapper>
      <Select value={engraving[index]} onChange={onChange} {...props}>
        <option label="" value={space} />
        {letters.map((letter) => (
          <option key={letter} label={letter} value={letter}>
            {letter}
          </option>
        ))}
      </Select>
    </SelectWrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 650px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Razor = styled.div`
  background-image: url(${({ gold }) => (gold ? goldRazorImage : razorImage)});
  background-repeat: no-repeat;
  background-size: 540px;
  display: block;
  position: relative;
  border-radius: 10px;
  width: 200px;
  height: 100px;
  border: 1px solid ${color.midGrey};
  background-position: left 0 top 50%;
  transform: rotate(180deg);
  color: ${({ gold }) => (gold ? color.lightGold : color.shipGrey)};
`;

const Engraving = styled.div`
  font-family: helvetica;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 4px;
  position: absolute;
  text-shadow: 0px 1px 1px ${color.dustyGrey};
  text-transform: uppercase;
  left: 90px;
  top: 50%;
  transform: translate(-50%, -50%) rotate(180deg);
  user-select: none;
`;

const EngravingSelection = styled.div`
  padding: 20px 0;
  @media (min-width: 650px) {
    margin-right: 20px;
  }
`;

const SelectWrapper = styled.div`
  background-repeat: no-repeat;
  position: relative;
  z-index: 10;
  padding-right: 0;
  border: 1px solid ${color.midGrey};
  overflow: hidden;
  margin-right: 10px;
  float: left;
  border-radius: 5px;
  background-image: url(${selectionArrowIcon});
  background-position: 90% center;
  background-size: 17px;
`;

const Select = styled.select`
  appearance: none;
  background-color: transparent;
  background-image: none;
  border-radius: 0;
  border: 0;
  box-shadow: none;
  color: ${color.grey};
  display: block;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  height: auto;
  padding: 20px 18px;
  position: relative;
  text-decoration: none;
  width: 100%;
`;
